/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Step_3Inputs */

const en_svc_n8n_step_3 = /** @type {(inputs: Svc_N8n_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test it on real data, including the awkward cases.`)
};

const lv_svc_n8n_step_3 = /** @type {(inputs: Svc_N8n_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudām to ar reāliem datiem, arī neērtajos gadījumos.`)
};

/**
* | output |
* | --- |
* | "Test it on real data, including the awkward cases." |
*
* @param {Svc_N8n_Step_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_step_3 = /** @type {((inputs?: Svc_N8n_Step_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Step_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_step_3(inputs)
	return en_svc_n8n_step_3(inputs)
});